import {IAdSlot} from 'modules/reducers/adSlots';
import {createAction} from 'redux-act';

export const fetchAdSlotsJSON = createAction();
export const fetchAdSlotsJSONSuccess = createAction<IAdSlot>();
export const fetchAdSlotsJSONFailed = createAction();